import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchProjectsIfNeeded } from 'data/actions/projects';
import Project from 'components/organisms/project';

class projectContainer extends Component {
    componentDidMount() {
        this.props.fetchProjectsIfNeeded();
    }

    componentDidUpdate(prevProps) {}

    render() {
        return <Project {...this.props} />;
    }
}

const mapStateToProps = (state, ownProps) => {
    if (!state.projects.all.length) {
        return {
            isLoading: true
        };
    }

    const project = state.projects.all.find(item => {
        return item.fields.slug === ownProps.match.params.id;
    });

    return {
        title: project.fields.title,
        path: ownProps.match.url,
        vimeoURL: `https://player.vimeo.com/video/${project.fields.videoID}`,
        coverURL: project.fields.previewImage.fields.file.url,
        coverTitle: project.fields.previewImage.fields.title,
        stills: project.fields.stills,
        metaData: [
            {
                title: 'Client',
                value: project.fields.client.fields.title
            },
            {
                title: 'Production company',
                value: project.fields.productionCompany.fields.title
            },
            {
                title: 'Director',
                value: project.fields.director.fields.title
            },
            {
                title: 'Camera',
                value: project.fields.camera.fields.title
            }
        ],
        isLoading: false,
        hasLoaded: state.projects.hasLoaded
    };
};

projectContainer = connect(mapStateToProps, { fetchProjectsIfNeeded })(
    projectContainer
);

export default withRouter(projectContainer);



// WEBPACK FOOTER //
// ./src/data/containers/project.js